<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="退款单号" name="refund_number"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="收货人电话" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="退款单状态" name="state" :options="refundState"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table" code="refund_list">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="70"
				>
					<template v-slot="{data}">
						<span style="color:#182eff" v-if="data.state==1">{{orderStateName[data.state]}}</span>
						<span style="color:darkgreen" v-if="data.state==2">{{orderStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==3">{{orderStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==4">{{orderStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="退款单号"
					name="refund_number"
					width="130"
				></c-table-column>
				
				<c-table-column
					label="订单号"
					name="order_number"
				  width="120"
				></c-table-column>
				
				<c-table-column
					label="推送状态"
					name="push_state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0"><span style="color:#bbbbbb">无需推送</span></span>
						<span v-if="data.push_state==1"><span style="color:#182eff">待推送</span></span>
						<span v-if="data.push_state==2"><span style="color:darkgreen">已推送</span></span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="售后三方单号"
					name="out_refund_number"
					width="140"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0">--</span>
						<span v-if="data.push_state==1">--</span>
						<span v-if="data.push_state==2">{{data.out_refund_number}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="用户名"
					name="login_name"
				  width="120"
				></c-table-column>
		
				<c-table-column
					label="手机号"
					name="user_manage_mobilephone"
				  width="120"
				></c-table-column>
				
				<c-table-column
					label="收件人"
					name="receiving_name"
				  width="120"
				></c-table-column>
		
				<c-table-column
					label="商品数量"
					name="product_count"
				  width="80"
				></c-table-column>
				
				<c-table-column
					label="商品退款"
					name="product_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.product_money&&data.product_money>0">￥{{data.product_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="运费退款"
					name="logistics_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.logistics_money&&data.logistics_money>0">￥{{data.logistics_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="服务费退款"
					name="other_fee"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.other_fee&&data.other_fee>0">￥{{data.other_fee.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="退款总额"
					name="refund_total_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.refund_total_money&&data.refund_total_money>0">￥{{data.refund_total_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
				  width="140"
				></c-table-column>
				
				<!-- <c-table-column
					label="运营方式"
					name="operation_mode"
				>
					<template v-slot="{data}">
						{{orderTypeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="自营商名称"
					name="stationed_name"
				></c-table-column> -->
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/refund_detail/${data.refund_number}`)">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_order_refund',

        props: {
            state: String,
            refund_state: String,

        },

		data() {
			return {
				orderStateName: {
					1: '待审核',
					2: '审核通过',
					3: '已驳回',
					4: '已撤销'
				},
				orderTypeName: {
					1: '平台自营',
					2: '商家自营'
				},
				refundState: [{
						name: '待审核',
						value: 1
					},{
						name: '审核通过',
						value: 2
					},{
						name: '已驳回',
						value: 3
					},{
						name: '已撤销',
						value: 4
					}
				]
			}
		},

        computed: {
            defaultSearch() {
                let param = {
                    state: this.state ? this.state.split(',') : [],
                }

                if (this.refund_state == 1) {
                    param.start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('refund.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/refund/list',
					data
				});
			}
		}
	}
</script>